export default __webpack_public_path__ + "4ca15a681d1afb87d0c8a525e1e1254e.svg";